import { StyleProps, CSS } from "@shared/primitive-components"

export const root = (): CSS => ({
  width: `100%`,
  position: `relative`,
  zIndex: `1`,
  aspectRatio: `1 / 1`,
})

export const rangeStart = (props: StyleProps): CSS => ({
  position: `absolute`,
  left: 0,
  bottom: props.theme.spacing(6),
  fontSize: `12px`,
  fontWeight: 500,
  textAlign: `left`,
})

export const rangeEnd = (props: StyleProps): CSS => ({
  position: `absolute`,
  right: 0,
  bottom: props.theme.spacing(6),
  fontSize: `12px`,
  fontWeight: 500,
  textAlign: `right`,
})

export const needle = (offset: number) => (): CSS => ({
  width: `100%`,
  height: `100%`,
  position: `absolute`,
  left: 0,
  top: 0,
  display: `flex`,
  alignItems: `center`,
  justifyContent: `center`,
  paddingTop: `${offset}%`,
  pointerEvents: `none`,
  zIndex: -1,
})

export const needleDial = (rotate: number) => (): CSS => ({
  width: `160px`,
  height: `160px`,
  borderRadius: `9999px`,
  position: `relative`,
  transform: `rotate(${rotate}deg)`,
  "@keyframes rotate": {
    from: { transform: `rotate(-30deg)`, opacity: 0 },
    to: { transform: `rotate(${rotate}deg)`, opacity: 100 },
  },
  animationDuration: `1s`,
  animationName: `rotate`,
  animationTimingFunction: `ease-in-out`,
})

export const needleArm = (): CSS => ({
  width: `100%`,
  position: `absolute`,
  left: `50%`,
  top: `50%`,
  transform: `translate(-50%, -50%)`,
  borderRadius: `20px`,
})

export const needlePoint = (): CSS => ({
  width: `19px`,
  height: `17px`,
  position: `absolute`,
  left: `0%`,
  top: `50%`,
  transform: `translate(0, -50%) rotate(-90deg)`,
})
